/* eslint-disable max-lines */
import { ArticleResolution } from '@wix/answers-api';
import { PageType } from './types';

export const PAGES = {
  ARTICLE: PageType.Article,
  CATEGORY: PageType.Category,
  SEARCH_RESULTS: PageType.SearchResults,
  HOMEPAGE: PageType.Homepage,
  TICKET: PageType.Ticket,
  HOME: PageType.Homepage,
  ROADMAP: PageType.RoadMap,
  PROFILE: PageType.Profile,
  CONTACT: PageType.Contact,
};

export const ROADMAP_RESOLUTIONS = [
  ArticleResolution.COLLECTING_VOTES,
  ArticleResolution.PLANNED,
  ArticleResolution.IN_DEVELOPMENT,
  ArticleResolution.COMING_SOON,
  ArticleResolution.RELEASED,
];

export const LOCALES = {
  DE: 'de',
  EN: 'en',
  ES: 'es',
  FR: 'fr',
  HE: 'he',
  IT: 'it',
  JA: 'ja',
  KO: 'ko',
  NL: 'nl',
  PT: 'pt',
  RU: 'ru',
  TR: 'tr',
  UK: 'uk',
};

export const WIX_STUDIO_SUPPORTED_LANGUAGES = [
  LOCALES.EN,
  LOCALES.DE,
  LOCALES.ES,
  LOCALES.FR,
  LOCALES.JA,
  LOCALES.PT,
];

export const HEADER_FOOTER_SUPPORT_LANGUAGES = [
  'en',
  'de',
  'es',
  'fr',
  'it',
  'nl',
  'pt',
  'ru',
  'ja',
  'ko',
  'tr',
  'hi',
  'cs',
  'th',
  'zh',
  'uk',
  'vi',
  'id',
];

export const HARDCODED_TEMP_LABELS = [
  { name: 'Roadmap: Billing', id: 'cc1d7a25-883f-4873-9385-10a995bbe031' },
  {
    name: 'Roadmap: Branded App by Wix',
    id: 'd7cd78f9-55ff-4c71-b7ae-9544b6e9bd56',
  },
  {
    name: 'Roadmap: Business Email',
    id: 'bdd9bc19-adf4-4a21-886e-4f8ac6770343',
  },
  { name: 'Roadmap: CMS', id: 'ed33803d-1aef-44ff-a154-abd144970fa0' },
  {
    name: 'Roadmap: Customer Care',
    id: '2d9552fc-d4d4-4ab1-8f4e-12ed5a552aff',
  },
  {
    name: 'Roadmap: Developer Platform',
    id: 'b3ec01d1-a4a7-402d-a4df-7c7f3347fc5d',
  },
  { name: 'Roadmap: Editor X', id: '3008b109-b7ca-45cc-b80b-942a91fac828' },
  {
    name: 'Roadmap: Email Marketing',
    id: 'd10eb0a1-6c3d-414b-94bc-d0af1a3d2823',
  },
  {
    name: 'Roadmap: Point of Sale (POS)',
    id: '2db5aad5-5f44-4daa-91e1-c5557feef594',
  },
  { name: 'Roadmap: Portfolio', id: 'a8af7a11-a6da-477c-aec0-ebd95d8c4422' },
  { name: 'Roadmap: SEO', id: '36db0d65-94e5-4f70-be67-89d9c6ab8a1d' },
  { name: 'Roadmap: Site Members', id: '7fe99482-c2f9-4c2c-9f86-8139193f4040' },
  { name: 'Roadmap: Velo', id: '18d84448-9998-4590-a9d8-098a8678b9a4' },
  {
    name: 'Roadmap: WOW (Visual Innovation Team)',
    id: 'c7b174d5-fd6a-4cac-b69b-079aa7f2fdb3',
  },
  {
    name: 'Roadmap: Wix Analytics',
    id: 'd23404df-b5ac-4bbc-a374-851969c44701',
  },
  {
    name: 'Roadmap: Wix App Market',
    id: '288f0de3-9002-4b7a-904d-3c86a74d3410',
  },
  {
    name: 'Roadmap: Wix Automations',
    id: '10f83b99-80ee-42a4-80b6-ac3c32d26d6f',
  },
  { name: 'Roadmap: Wix Blog', id: 'c9a46fd8-6919-4969-a26c-dc03f5c60e25' },
  { name: 'Roadmap: Wix Bookings', id: 'ca8c47bc-ff69-4006-a0b7-b524906ecabe' },
  {
    name: 'Roadmap: Wix Components',
    id: '49e28ecb-bea9-440f-99d6-bfe9d3b83075',
  },
  { name: 'Roadmap: Wix Editor', id: '5e2c392b-8762-4d09-8a0d-121de62d37d8' },
  { name: 'Roadmap: Wix Events', id: 'bb63fb95-07a9-44f8-a364-8b05635be4b1' },
  { name: 'Roadmap: Wix Forms', id: '9d4aab81-bd60-4280-9ba2-1e9127156293' },
  { name: 'Roadmap: Wix Groups', id: '54726eb7-3c36-4a2c-a549-5532c8e461cd' },
  { name: 'Roadmap: Wix Headless', id: '487ce0a0-ed15-4714-8bb2-a5098f4270d1' },
  { name: 'Roadmap: Wix Invoices', id: 'caebce05-1dc1-4821-9244-e18f092b5e3f' },
  {
    name: 'Roadmap: Wix Logo Maker',
    id: '75fe84b6-42b7-42f5-9c72-240c5ef6615b',
  },
  {
    name: 'Roadmap: Wix Loyalty Program',
    id: 'bf421dd9-1590-480e-9a5a-6c1b3929fbe8',
  },
  { name: 'Roadmap: Wix Media', id: '935f8289-3baa-4ec9-b7bb-1c78b2408fab' },
  {
    name: 'Roadmap: Wix Mobile Apps',
    id: '5dd6e5dd-280c-4721-af44-10282b0e92d0',
  },
  {
    name: 'Roadmap: Wix Multilingual',
    id: 'ed9e1392-735e-4bdb-beb4-0952dd3a971a',
  },
  {
    name: 'Roadmap: Wix Online Programs',
    id: 'b598380d-ddb1-46b2-b1b3-a86d8664b536',
  },
  {
    name: 'Roadmap: Wix Pricing Plans',
    id: '2aca7691-dfeb-4c68-962c-adb5132af195',
  },
  {
    name: 'Roadmap: Wix Restaurants',
    id: 'd6dd504d-fd50-436a-af68-16b9e9477374',
  },
  { name: 'Roadmap: Wix SMS', id: 'e0eaa21e-c164-4cc4-9f6d-123542dd70e5' },
  { name: 'Roadmap: Wix Stores', id: 'b2cd4c53-c6c8-4287-865c-2187eb527871' },
];

export const MOCKED_ROADMAP_LABELS = [
  {
    id: '5e2c392b-8762-4d09-8a0d-121de62d37d8',
    name: 'Roadmap: Wix Editor',
  },
  {
    id: 'ca8c47bc-ff69-4006-a0b7-b524906ecabe',
    name: 'Roadmap: Wix Bookings',
  },
  {
    id: 'c9a46fd8-6919-4969-a26c-dc03f5c60e25',
    name: 'Roadmap: Wix Blog',
  },
  { id: '18d84448-9998-4590-a9d8-098a8678b9a4', name: 'Roadmap: Velo' },
  {
    id: '9af919a1-8b25-4ce9-a4a5-d807519011ae',
    name: 'Roadmap: Wix Stores',
  },
];

export const EDITORS_NAMES = ['ADI', 'Wix Editor', 'Editor X'];

export const URL_MSID_PATTERN =
  /[\da-f]{8}-[\da-f]{4}-[0-5][\da-f]{3}-[089ab][\da-f]{3}-[\da-f]{12}/;

export const BI = {
  SOURCE_NAMES: {
    ARTICLE: 'article',
    SEARCH_RESULTS: 'search_results',
    CATEGORY: 'category',
    TICKET: 'ticket',
    HOME: 'home',
    PROFILE: 'user_profile',
    ROADMAP: 'roadmap',
    CONTACT: 'contact',
  },

  SOURCE_COMPONENT_NAME: {
    WISHLIST_FORM: 'wishlist_form',
  },
  ITEM_TYPES: {
    KNOWN_ISSUE: 'known_issue',
    FEATURE_REQUEST: 'feature_request',
    ARTICLE: 'article',
    TICKET: 'ticket',
    PROFILE: 'user_profile',
    INCIDENT_BANNER: 'incident_banner',
  },
  ITEM_NAMES: {
    HELPFUL_VOTE_OPTION: 'helpful vote option',
    HIRE_A_PARTNER: 'hire a partner',
    VOTE: {
      FEATURE_REQUEST_VOTE: 'feature request vote option',
      FEATURE_REQUEST_FOLLOW: 'feature request follow option',
      KNOWN_ISSUE_VOTE: 'known issue vote option',
    },
  },
  CLICKED_ITEM_TYPES: {
    SECTION_EXPAND: 'section_expand',
    SECTION_COLLAPSE: 'section_collapse',
    ANCHOR: 'anchor',
    CATEGORY_SELECTION: 'category_selection',
    SEE_ALL: 'see_all',
    SUB_CATEGORY_SELECTION: 'sub_category_selection',
    ARTICLE_SELECTION: 'article_selection',
    FEATURE_REQUEST_SELECTION: 'feature_request_selection',
    KNOWN_ISSUE_SELECTION: 'known_issue_selection',
    HOME_PAGE: 'home_page',
    INTERNAL_LINK: 'internal_link',
    EXTERNAL_LINK: 'external_link',
    EXTERNAL_FORM_LINK: 'form_opened_via_external_link',
    ARTICLE_LINK: 'article_link',
    CTA: 'CTA',
    RELATED_CONTENT: 'related_content',
    PICTURE: 'picture',
    ALL_TOPICS: 'all_topics',
    PAGE_ACTION: 'page_action',
    TRENDING_TOPICS: 'trending_topics',
    TRENDING_TOPICS_CATEGORY: 'trending_topics_category',
    TRENDING_TOPICS_ARTICLE: 'trending_topics_article',
    HIRE_A_WIX_PARTNER: 'hire_a_wix_partner',
    TAB_SELECTION: 'tab_selection',
    BREADCRUMBS: 'breadcrumbs',
    RESIZE: {
      INCREASE: 'resize_increase',
      DECREASE: 'resize_decrease',
    },
    MORE_RESOURCES: 'more_resources',
    WIX_STUDIO_COMMUNITY_FORUM: 'wix studio community forum',
    CLOSE: 'close',
    CANCEL: 'cancel',
    SEND: 'send',
    BACK: 'back',
    VOTE: 'vote',
    FOLLOW: 'follow',
    PAGE_SELECTION: 'page_selection',
    TAG_SELECTION: 'tag_selection',
    WISHLIST: {
      SEND: 'send',
      SEND_WITH_SUGGESTED: 'send with alternative suggested',
      SEND_AFTER_SUGGESTED: 'send my feature',
    },
  },
  USP: {
    TOOLTIP_MINIMIZED: 'minimized',
    TOOLTIP_OPEN: 'open',
    STATE: {
      ACTIVE: 'active',
      NOT_ACTIVE: 'not_active',
    },
    CLICKED_ITEM: {
      TOOLTIP_CLOSED: 'tooltip_closed',
      MAIN_CTA: 'main_cta',
      SECONDARY_CTA: 'secondary_cta',
      TOOLTIP_CLICK: 'tooltip_click',
    },
  },
  SELECTORS: {
    COLLAPSIBLE_COMPONENTS: '.collapsible-heading',
    CLICKABLE_IMAGES: 'img[class="clickable"]',
    CUSTOM_HTML_ARTICLE_CTA_BUTTON: 'action-box-action-btn',
    CUSTOM_HTML_ARTICLE_LOG_IN_BUTTON: 'article-log-in-button',
    CUSTOM_HTML_ARTICLE_GET_STARTED_BUTTON: 'article-get-started-button',
    PAGE: '#__next',
    HEADER: 'header',
    TABS: '.tab-heading',
  },
  SEARCH_RESULT_SELECTION: {
    SEARCH_BAR_DROPDOWN_LIST: 'search_bar_dropdown_list',
    FULL_SEARCH_RESULTS_LIST: 'full_search_results_list',
  },
  USER_ENGAGEMENT_PINGER_INTERVAL:
    process.env.NODE_ENV === 'test' ? 1000 : 10000,
  FEEDBACK_DETAILS: {
    OLD: 'old_feedback_form',
    NEW: 'new_feedback_form',
  },
  HIRE_A_PARTNER: {
    OLD: 'a_hire_a_partner',
    NEW: 'b_hire_a_partner',
  },
  BANNERS_TYPE: {
    STATUS_PAGE: 'status_page',
    HELP_CENTER: 'help_center',
  },
  WISHLIST_FORM: {
    MAIN: 'main',
    ALTERNATIVE_SUGGESTER: 'alternative_suggester',
  },
  PERSONALIZED_CONTENT_SECTIONS: {
    TRENDING_ARTICLES: 'Trending Articles',
  },
};

export const PRODUCTION_DOMAIN = 'support.wix.com';

export const WIX_STUDIO_COMMUNITY_FORUM_LINK = `https://forum.wixstudio.com/?utm_source=cc_help_center`;

export const CHATBOT_URL =
  'https://www.wix.com/support-chatbot?t=2&alert=0&nodeId=RNc3EQNG7DHSFMjbPaLn&referral=';

export const WIX_CONTACT_URL =
  'https://www.wix.com/contact?&referral=answers_submit_ticket';

export const ANSWERS_API_BASE_URL = `https://${PRODUCTION_DOMAIN}/api/v1`;

export const API_CLIENT_ID = '57999a1b-940f-4227-adca-c554628ea935';

export const EXPERIMENTS = {
  ID: '__EXPERIMENTS__',
  SCOPES: ['customer-care'],
  SPECS: {
    REDIRECT_FROM_HELP_CENTER_ON_NOT_HELPED:
      'specs.engage.RedirectFromHelpCenterOnNotHelped',
    REDIRECT_FROM_HELP_CENTER_ONLY_BILLING_PREMIUM:
      'specs.engage.RedirectFromHelpCenterOnlyBillingPremium',
    SHOW_USP_TOOLTIP: 'specs.UspTooltip',
    BACKUP_CONTACT_PAGE: 'specs.backupContactPage',
    BACKUP_CONTACT_PAGE_TEST: 'specs.backupContactPageTest',
    ARTICLE_FEEDBACK: 'specs.ArticleImprovedFeedback',
    ENABLE_VESPA_SEARCH_EXCEPT_HE: 'specs.EnableVespaSearchExceptHE',
    ENABLE_VESPA_SEARCH_IN_HE: 'specs.EnableVespaSearchInHE',
    NEW_SEARCH_RESULTS_PAGE: 'specs.NewSearchResultsPage',
    ENABLE_MINI_PERSONALIZATION: 'specs.EnableMiniPersonalization',
    RELATED_CONTENT_MINI_PERSONALIZATION:
      'specs.RelatedContentMiniPersonalization',
    SUGGEST_SIMILAR_FR: 'specs.SuggestSimilarFR',
    NEW_SEARCH_BAR_RESULTS: 'specs.NewSearchBarResults',
    NEW_ARTICLE_STATUS_AND_VOTE: 'specs.NewArticleStatusAndVote',
    EDITOR_X_NOTIFICATION: 'specs.EditorXNotification',
    CATEGORY_DESCRIPTION: 'specs.CategoryDescription',
    REDIRECT_TO_SEARCH_RESULTS_PAGE_ON_ENTER: 'specs.RedirectToSearchResultsPageOnEnter',
    NEW_SEARCH_RESULTS_PAGE_ALL_LOCALES: 'specs.NewSearchResultsPageAllLocales',
    PERSONALIZED_TRENDING_ARTICLES: 'specs.PersonalizedTrendingArticles',
  },
};

export const EMPTY_CATEGORY_ID = '00000000-0000-0000-0000-000000000000';

export const ARTICLES_PAGE_SIZE = 350;

export const SEARCH_ARTICLES_PAGE_SIZE = 20;

export const CATEGORY_ARTICLES_PAGE_SIZE = 20;

export const BILLING_AND_PREMIUM_CATEGORIES = [
  'f78196b2-7b20-45d1-9ec2-3fb4504c6c38',
  '11af63e5-e36f-45c7-8596-031ac665e06d',
  '04e9f910-d5f6-44ea-b702-1646844dd106',
  'f2bb50e4-d721-4709-b94e-29b04d0d2451',
  'd3a9282e-b06f-4dc3-a973-1d36477461d7',
  '967ff141-bc5d-4a18-b664-10f7495da15e',
  '75c5cb39-36b5-4fe0-a7d2-2f4c1fae0ab3',
  'ce454447-8a62-4431-9b84-1ec3e3a1f46b',
  '2ec24e03-f797-4a78-939a-f1a02c9eb329',
  '35473554-6809-447f-916a-e38527ebcd39',
];

export const WIX_STATUS_DOMAIN = 'https://status.wix.com';

export const WIX_STATUS_PATH = '/api/v2/incidents.json';

export const SEO = {
  PLACEHOLDERS: {
    CATEGORY_TITLE: '$CATEGORY_TITLE',
    COMPANY_NAME: '$COMPANY_NAME',
    ARTICLE_TITLE: '$ARTICLE_TITLE',
    ARTICLE_PREVIEW: '$ARTICLE_PREVIEW',
  },
  COMPANY_NAME: 'Wix Support',
};

export const PAGE_TYPE_SEO_RPC = {
  ARTICLE: 'ARTICLE',
  CATEGORY: 'CATEGORY',
  CONTACT_PAGE: 'CONTACT_PAGE',
  HOME_PAGE: 'HOME_PAGE',
  SEARCH_RESULTS: 'SEARCH_RESULTS',
};

export const ONE_HOUR_MS = 3600000;

export const FEDOPS = {
  INTERACTION_NAMES: {
    SEARCH_ARTICLES: 'search_articles',
    VOTE_ARTICLE: 'vote_article',
    HELPFUL_ARTICLE: 'helpful_article',
    SUBMIT_TICKET: 'submit_ticket',
    ADDITIONAL_FEEDBACK: 'additional_feedback',
  },
};

export const SLED = {
  COOKIES: {
    PETRI_OVR: 'petri_ovr',
  },
  HEADERS: {
    DEPLOY_PREVIEW: 'x-wix-route-kb-client-nextjs',
  },
  QUERY_PARAMS: {
    X_WIX_ROUTE: 'x-wix-route',
  },
};

export const WIX_RECAPTCHA_KEY = '6Le_WGgdAAAAAPDQseS7wvNTDEYsdzlq1EOpyGQF';

export const SENTRY = {
  DSN: 'https://845a4a6ee7a84ecda9d0d38fdc945bf0@sentry-next.wixpress.com/2742',
};

export const REDIS = {
  GET_HELP_CENTER_DATA: { KEY: 'getHelpCenterData', TTL: 300 },
  GET_CATEGORY_BY_URI: { KEY: 'getCategoryByUri', TTL: 300 },
  GET_PAGE_SEO: { KEY: 'getPageSeo', TTL: 300 },
  GET_TENANT_INFO: { KEY: 'getTenantInfo', TTL: 300 },
  GET_LABELS: { KEY: 'getLabels', TTL: 300 },
  GET_ARTICLE_TYPE_COUNT: { KEY: 'getArticleTypeCount', TTL: 300 },
  SEARCH_ARTICLES: { KEY: 'searchArticles', TTL: 300 },
};

export const isInternalRoute = (url?: string): boolean =>
  !!url?.startsWith('/_next/data');

export const AGENT_TOOLBAR = {
  CLASSES: {
    OPEN: 'agent-toolbar-open',
    CLOSE: 'agent-toolbar-close',
    CONTAINER: 'user-toolbar-container',
  },
};

export const DEFAULT_SEARCH_METHOD = 'Answers';

export enum SearchResultsFilter {
  ALL = 'all',
  ARTICLES = 'articles',
  KNOWN_ISSUES = 'known-issues',
  ROADMAP = 'roadmap',
  FEATURE_REQUESTS = 'feature-requests',
}

export const COOKIES = {
  WIX_CLIENT_ID: '_wixCIDX',
  WIX_LANGUAGE: 'wixLanguage',
  WIX_CLIENT: 'wixClient',
  WIX_ANSWERS_CLIENT_ID: '_AC',
  WIX_UID: '_wixUIDX',
};

export const LOCAL_STORAGE_PREFIX = {
  FEEDBACK_VOTE: 'feedback-vote-',
  ADDITIONAL_FEEDBACK_OPTION: 'additional-feedback-',
};

export const HIRE_A_PARTNER_LOCALES = [LOCALES.EN, LOCALES.PT];

export const TRENDING_ARTICLES_NUM_ITEMS = 5;
export const TOPICS_SECTION_NUM_ITEMS = 9;

export const ALL_PRODUCTS_LABEL_ID = '0000000000000';

export const AUTO_VOTE = 'autoVote';

export const TOOLTIP_ENTER_DELAY = 300;

export const BI_PROFILE_USER_TRENDING_ARTICLES_FIELD = 'user_trending_articles';
